import { render, staticRenderFns } from "./TutorCardDocumentation.vue?vue&type=template&id=33874504&scoped=true&"
import script from "./TutorCardDocumentation.vue?vue&type=script&lang=js&"
export * from "./TutorCardDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./TutorCardDocumentation.vue?vue&type=style&index=0&id=33874504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33874504",
  null
  
)

export default component.exports